/*=========================================================================================
  File Name: moduleUnitActions.js
  Description: Unit Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from "@/plugins/axios";

export default {

  //reset the password by get token from api
  async CreateKitchens({ }, Credentials) {

    delete Credentials.id;
    delete Credentials.is_active;
    return new Promise((resolve, reject) => {
      axios
        .post("/hms/kitchens", Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },


  GetKitchensSearch({ }, payload) {

    let url = "/hms/kitchens/search?";
    if (payload != null && payload != undefined) {
      if (payload.query != "" && payload.query != null) {
        url += `query=${payload.query}&`;
      }

      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {

          console.log("resp.data", resp.data);
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },



  async Get({ }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/hms/kitchens`)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  async EditKitchens({ }, Credentials) {

    return new Promise((resolve, reject) => {
      let ID = Credentials.id;
      //delete Credentials.is_active;
      delete Credentials.created_at;
      delete Credentials.id;
      delete Credentials.updated_at;
      delete Credentials.deleted_at;
      delete Credentials.is_active;

      delete Credentials.user_id;
      axios
        .patch(`/hms/kitchens/${ID}`, Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  DeleteKitchen({ }, Id) {

    return new Promise((resolve, reject) => {
      axios
        .delete(`/hms/kitchens/${Id}`)
        .then((resp) => {
          console.log("Request succeeded", resp);
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  ActiveOrArchiveKitchens({ }, Id) {

    return new Promise((resolve, reject) => {
      axios
        .get(`/hms/kitchens/${Id}/soft-delete`)
        .then((resp) => {
          console.log("Request succeeded", resp);
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  GetKitchen({ }, payload) {

    let url = "/hms/kitchens/search?";
    if (payload != null && payload != undefined) {
      if (payload.query != "" && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (
        payload.status != undefined &&
        payload.status != null
      ) {
        url += `status=${payload.status}&`;
      }
      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }

    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {

          console.log("resp.data", resp.data.data);
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  GetRooms({ }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .get("/hms/rooms/search", {
          params: {
            except: payload.except ? JSON.stringify(payload.except) : null,
            status: payload.status,
            query: payload.query,
            limit: 100,
          },
        })
        .then((resp) => {
          console.log("GetRooms API Response Length:", resp.data.data.length);
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

};
